import OrderAssignDialog from './order-assign-dialog.vue'

OrderAssignDialog.install = function (Vue) {
    Vue.component(OrderAssignDialog.name, OrderAssignDialog);
}

export default OrderAssignDialog;